import { ApplicationState, AppThunkDispatch } from "../../store";
import { connect } from "react-redux";
import ExpenseForm from "../../components/Forms/ExpenseForm";
import { ExpenseEntity } from "../../store/entities/state";
import { getChangingState, getChangingValue, isSubmittingNew } from "../../store/entities/selectors";
import { createEntity, entityCreatingCancel, updateChangingEntity, loadEntities } from "../../store/entities/actions";
import { createExpenseAsync, getExpenseAsync } from "../../ajax/requests";
import { ExpenseFormDispatchProps, ExpenseFormStateProps } from "../../components/Forms/ExpenseForm/ExpenseForm";
import { alertSuccess } from "../../store/alerts/actions";
import { TK } from "../../store/translations/translationKeys";
import { translate } from "../../store/translations/hooks";

const mapStateToProps = (state: ApplicationState): ExpenseFormStateProps => ({
    type: 'create',
    canEdit: true,
    data: getChangingValue(state, 'expenses') as ExpenseEntity,
    hasChanged: getChangingState(state, 'expenses'),
    isSubmitting: isSubmittingNew(state, 'expenses'),
})

const mapDispatchToProps = (dispatch: AppThunkDispatch): ExpenseFormDispatchProps => ({
    onChange: (data: ExpenseEntity) => dispatch(updateChangingEntity('expenses', data)),
    onCancel: () => dispatch(entityCreatingCancel('expenses')),
    onSave: async (data: ExpenseEntity, files?: File[]) => {
        const id = await dispatch(createEntity('expenses', data, e => createExpenseAsync(e, files)));
        
        if (id) dispatch(alertSuccess(translate(TK.entityCreatedSuccessfully)));

        // Reload the expense from server if files were uploaded to get the proper attachment URLs
        if (id && files && files.length > 0) {
            await dispatch(loadEntities('expenses', () => getExpenseAsync(id), 'AppendResult'));
        }
    },
});

export default connect<ExpenseFormStateProps, ExpenseFormDispatchProps, unknown, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(ExpenseForm as any);
